import styles from "./ProductPlaceholder.module.scss";

import IconHeart from "@/images/icons/brand/heart.svg";

interface ProductPlaceholderProps {}

export const ProductPlaceholder = ({}: ProductPlaceholderProps) => {
	return (
		<div className={styles["product-placeholder"]}>
			<IconHeart />
			<p>Enter your address above and we’ll show you the relevant products here</p>
		</div>
	);
};
